<template>
  <div>
    <b-col>
      <div class="custom-control custom-switch">
        <input type="checkbox" name="check-button" class="custom-control-input" @change="autoPrintFunction()"
               v-model="autoPrint"
               id="publishedCheckbox"/>
        <label class="custom-control-label" for="publishedCheckbox">چاپ خودکار فاکتور</label>
      </div>
    </b-col>

    <table-items :items="items" :restoreState="false"/>
    <div class="row pt-3">
      <div class="mt-3 color">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </div>
    </div>
  </div>
</template>

<script>
import tableItems from "../../components/dashboard/orders/tableItems.vue";
import Pagination from "../../components/dashboard/Pagination";

import {mapGetters} from "vuex";

export default {
  name: "AllOrders",
  components: {tableItems, Pagination},
  data() {
    return {
      autoPrint: false,
      printedOrders: [],
      updateList: false,
    }
  },
  computed: {
    ...mapGetters({
      items: "ShoppingCart/getOrders",
      paginationMeta: "ShoppingCart/getPaginationMeta",
    }),
  },
  methods: {
    changePage(page) {
      this.autoPrint = false;
      this.$store.dispatch("ShoppingCart/getAllOrders", page);
    },
    async setPrintedOrder() {
      this.printedOrders = []

      await this.items.forEach(item => {
        this.printedOrders.push(item.id)
      })

    },
    async autoPrintFunction() {


      if (this.autoPrint) {


        await this.$store.dispatch("ShoppingCart/getAllOrders");


        await this.items.forEach(item => {
          const condition = this.printedOrders.indexOf(item.id) == -1

          if (condition) {
            this.printedOrders.push(item.id)
            let routeData = this.$router.resolve({name: 'Factor', params: {orderId: item.id}, query: {print: 'on'}});
            window.open(routeData.href, '_blank');
          }

        })

        setTimeout(async function () {
          await this.autoPrintFunction()
        }.bind(this), 5_000)


      }


    },
  },
  async mounted() {

    await this.$store.dispatch("ShoppingCart/getAllOrders")

  },
  watch: {
    items(newValue) {
      if (!this.updateList) {
        this.setPrintedOrder()
        this.updateList = true
      }
    }
  }
};
</script>